@if (shouldBeVisible) {
  <div [formGroup]="gatewayForm">
    <!-- GATEWAY TYPE -->
    <div class="form-group">
      <label for="gatewayType" translate>Gateway type</label>
      <scitis-required-field-indicator></scitis-required-field-indicator>
      <ng-select
          (change)="onGatewayTypeChange($event)"
          [items]="possibleGatewayTypes"
          [ngClass]="{ 'is-invalid':  f.gatewayType.errors }"
          bindLabel="typeName"
          bindValue="typeName"
          formControlName="gatewayType"
          id="gatewayType">
      </ng-select>
      @if (f.gatewayType.errors) {
        <div class="invalid-feedback">
          @if (f.gatewayType.errors.required) {
            <span translate>Gateway type required</span>
          }
        </div>
      }
    </div>
    <!-- GATEWAY NAME & SERIAL NUMBER -->
    <div class="form-row">
      <!-- SERIAL NUMBER -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="serial" translate>Serial number</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          @if (isVerifyUsage) {
            <span class="fa-solid fa-gear fa-spin"></span>
          }
          <input
              (change)="onSerialNumberChange()"
              [ngClass]="{ 'is-invalid': f.serial.errors }"
              class="form-control" formControlName="serial" id="serial"
              name="serial" type="text">
          @if (f.serial.errors) {
            <div class="invalid-feedback">
              @if (f.serial.errors.required) {
                <span translate>Serial number required</span>
              }
              @if (f.serial.errors.min) {
                <span translate>The serial number must be at least 5 digits long!</span>
              }
              @if (f.serial.errors.used) {
                <span translate>The serial number already exists!</span>
              }
            </div>
          }
        </div>
      </div>
      <!-- name -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="name" translate>Name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input
              [ngClass]="{ 'is-invalid':  f.name.errors}"
              class="form-control"
              formControlName="name"
              id="name" name="name"
              type="text">
          @if (f.name.errors) {
            <div class="invalid-feedback">
              @if (f.name.errors.required) {
                <span translate>Gateway name required</span>
              }
              @if (f.name.errors.pattern) {
                <span
                    translate>The name can only consist of latin letters, numbers, underscores.</span>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <!-- CLOUDPLUG LIGHT & GENERIC SPECIFIC SETTINGS-->
    @if (isGenericGatewayOrCloudplugLight()) {
      <div class="form-row">
        <div class="col-12">
          <div class="form-row">
            <!-- REGISTRY ID -->
            <div class="col-12 col-lg-6">
              <div class="form-group">
                @if (loadRegistryIds) {
                  <span class="fa-solid fa-spinner fa-spin ml-2"></span>
                }
                <label for="registry" translate>Tenant Id</label>
                <scitis-required-field-indicator></scitis-required-field-indicator>
                <ng-select
                    [items]="iotCoreRegistryIds" [ngClass]="{ 'is-invalid': f.registry.errors }"
                    formControlName="registry"
                    id="registry">
                </ng-select>
                <input [hidden]="true" [ngClass]="{ 'is-invalid': f.registry.errors }" class="form-control"
                       id="registryName"
                       name="registryName"
                       type="text">
                @if (f.registry.errors) {
                  <div class="invalid-feedback">
                    @if (f.registry.errors.required) {
                      <span translate>Tenant id required</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
